import React, { useEffect } from 'react'
import PurchaseOrderDataDetails from "components/views/Synth2.0/Order/PurchaseOrderDetails"
import { useNav } from 'components/common/Navbar/NavContext';
import { useNavigate } from 'react-router-dom';

const PurchaseOrderDetails =()=> {
    const { setNavName, setOnClick, setShowNavIcon } = useNav();
const navigate = useNavigate()
    useEffect(() => {
        setNavName("Purchase Details");
        setOnClick(() => () => {
            navigate(-1);
        });
        setShowNavIcon(true)

    }, [setNavName, setOnClick, setShowNavIcon]);

    return (
        <PurchaseOrderDataDetails showTabs={false}/>
    )
}

export default PurchaseOrderDetails